export default __webpack_public_path__ + "locales/ro/VersionHistory.json?hash=a90f4924886ff64b186deb66aeccf5e4";